import { create } from 'zustand'

interface AddProfileDialogState {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
}

/**
 * Controls the reusable, closeable profile-onboarding dialog so an existing user
 * can add another profile. The trigger (user menu) and the globally-mounted host
 * are decoupled: the menu closing must not unmount the dialog.
 */
export const useAddProfileDialogStore = create<AddProfileDialogState>(
  (set) => ({
    open: false,
    openDialog: () => set({ open: true }),
    closeDialog: () => set({ open: false }),
  })
)
